import { useState } from "react"
import i18next from "i18next"
import { useCurrentLanguage } from "@/hooks/useCurrentLanguage"
import { changeLanguage } from "@/lib/language-storage"
import { UiDisplayLanguage } from "@/types/UiDisplayLanguage"

const useSwitchLanguage = () => {
  const currentLanguage = useCurrentLanguage()
  const [language, setLanguage] = useState(currentLanguage)

  const switchLanguage = (lang: UiDisplayLanguage) => {
    if (language !== lang) {
      setLanguage(lang)
      i18next.changeLanguage(lang)
      changeLanguage(lang)
    }
  }

  return [language, switchLanguage] as const
}

export default useSwitchLanguage
